import { cn } from '@heidi/utils';
import { cva } from 'class-variance-authority';

export const kbdVariants = cva(
  cn('inline-flex items-center justify-center text-text-secondary'),
  {
    variants: {
      size: {
        default: 'min-h-7 min-w-7 rounded-md px-1.5',
        compact: 'min-h-4 min-w-4 rounded-sm px-0.5',
      },
      inline: {
        true: 'min-h-0 min-w-0 border-0 p-0 leading-none',
        false: 'border border-border shadow-sm',
      },
    },
    defaultVariants: {
      size: 'default',
      inline: false,
    },
  }
);
